export default __webpack_public_path__ + "static/media/logout-icon.f2bc3820.svg";